module.exports = __webpack_public_path__ + "static/img/021abd59a62fe4a4f43b41fdeff9dd5f05.526df9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/newComing/021abd59a62fe4a4f43b41fdeff9dd5f05.jpg
// module id = kZWi
// module chunks = 0